import { render, staticRenderFns } from "./Stats.vue?vue&type=template&id=06c5b556&scoped=true&"
import script from "./Stats.vue?vue&type=script&lang=js&"
export * from "./Stats.vue?vue&type=script&lang=js&"
import style0 from "./Stats.scss?vue&type=style&index=0&id=06c5b556&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c5b556",
  null
  
)

export default component.exports